var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPinpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16.9,
    viewBox: "0 0 14 16.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M5.05,4.05a7,7,0,0,1,9.9,9.9L10,18.9,5.05,13.95A7,7,0,0,1,5.05,4.05ZM10,11A2,2,0,1,0,8,9,2,2,0,0,0,10,11Z",
    transform: "translate(-3 -2)",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPinpoint);
export default __webpack_public_path__ + "static/media/marker-pinpoint.d51e8d0e.svg";
export { ForwardRef as ReactComponent };